/* eslint-disable max-len, no-useless-escape */
export const emailReg: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const lettersReg: RegExp = /^[a-zA-Zа-яёА-ЯЁ\s]+(\s[a-zA-Zа-яёА-ЯЁ]+)*$/i;

export const birthdayReg: RegExp = /^(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](19|20)\d\d$/;

export const passportReg: RegExp = /^[a-zA-Z0-9]+$/;
/* eslint-enable max-len, no-useless-escape */
